import { Fragment, useEffect } from 'react'

import { ROUTE_HOME } from '@features/routes'
import { generateUrl } from '@services/routes'

import { useNavigate } from 'react-router-dom'

export const Loader = () => {
    const navigate = useNavigate()

    useEffect(() => {
        navigate(generateUrl(ROUTE_HOME))
    }, [])

    return (<Fragment></Fragment>)
}

export default Loader